define('controllers/about',['require','layout'],function (require) {
  var layout = require("layout");
  var aboutController = {
    load: function (querystring) {
      return layout.initStatic("/fe/templates/about/about").then(init);
      function init() {
        aboutController.mainslideshow =
          window.app.controllerManager.controllers.mainslideshow[0];
        aboutController.mainslideshow.load(null, querystring);

        layout.initGlobalHandlers();
        layout.hideMatchPlanTemplate();
        $("[data-800Number]").text(window.ServerData.Phones.MemberSupportPhone);
        $("[data-memberSupportEmail]").text(
          window.ServerData.Emails.MemberSupport,
        );
        $("[data-matchPlanPercentage]").text(
          window.ServerData.Settings.MatchPercentage,
        );
        $("[data-MemberSupportHours]").html(
          window.ServerData.Settings.MemberSupportHours.replace(
            "-br-",
            "<br/>",
          ),
        );
        if (window.ServerData.user == null) {
          $("#EnrollButton").show();
          $("#BookButton").hide();
        } else {
          $("#EnrollButton").hide();
          $("#BookButton").show();
        }
        if (
          window.ServerData.Settings.MatchPercentage.toLowerCase() !== "default"
        ) {
          var matchPercentageDecimal =
            parseFloat(window.ServerData.Settings.MatchPercentage);
          $("[data-matchPlanPercentageCents]").text(matchPercentageDecimal);
        }

        $("#finePrintTag").on("click", function (e) {
          e.preventDefault();
          $("#finePrintContent").slideToggle(600);
        });
      }
    },

    unload: function () {
      $("#finePrintTag").off("click");
      window.clearInterval(aboutController.slide);
      if (aboutController.mainslideshow != null) {
        aboutController.mainslideshow.unload();
      }
    },
  };
  return aboutController;
});

